import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  height: 22px;\n  margin-left: 30px;\n  margin-top: 3px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.57;\n  margin-bottom: 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  transition: opacity 150ms ease-in-out;\n\n  /* Note: This gives us room to render an error label below the checkbox */\n  padding-bottom: 30px;\n\n  &:active {\n    opacity: 0.5;\n  }\n\n  ", ";\n\n  > input {\n    margin-left: 6px;\n    margin-top: 17px;\n    opacity: 0;\n    position: absolute;\n\n    &:focus {\n      outline: 0;\n    }\n  }\n\n  > input + label {\n    font-size: 14px;\n    font-weight: normal;\n    color: ", ";\n    outline: 0;\n    cursor: pointer;\n    display: inline-block;\n    min-height: 22px;\n    min-width: 22px;\n    position: relative;\n    margin: 11px 0;\n\n    &::before,\n    &::after {\n      position: absolute;\n    }\n\n    &::before {\n      content: '';\n      display: inline-block;\n      height: 22px;\n      width: 22px;\n      border: solid 1px #cccfcf;\n      border-radius: ", ";\n      background-color: #ffffff;\n      left: 0;\n      top: 0;\n    }\n\n    &::after {\n      content: none;\n      display: block;\n      width: 22px;\n      height: 22px;\n      background: url(\"", "\") no-repeat center center;\n      background-size: 12px 9px;\n      left: 0;\n      top: 0;\n    }\n  }\n\n  > input:checked + label::after {\n    content: '';\n  }\n\n  > input:checked + label::before {\n    background: #74c947;\n    border-color: rgba(0,0,0,0);\n  }\n\n  > input:focus + label::before {\n    border: solid 1px ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../../utils/styling/styled-components';
import { CHECKBOX_INPUT, CHECKBOX_LABEL, CHECKBOX_TOP_LABEL } from '../../utils/testing/TestIDs';
import CheckSVGURL from '../check.svg';
import { FieldError } from '../FieldError';
var Container = styled.div(_templateObject(), function (props) {
  return props.disabled && "\n    opacity: 0.3;\n  ";
}, function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.theme.borderRadius.medium;
}, CheckSVGURL, function (props) {
  return props.theme.colors.stone;
}); // A3 designs have checkboxes with two labels

var FieldContext = styled.span(_templateObject2(), function (props) {
  return props.theme.colors.slate;
});
var LabelText = styled.span(_templateObject3());

var CheckboxInput = function CheckboxInput(_ref) {
  var checked = _ref.checked,
      className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      errorText = _ref.errorText,
      id = _ref.id,
      label = _ref.label,
      onChange = _ref.onChange,
      name = _ref.name,
      topLabel = _ref.topLabel;
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    disabled: disabled,
    "data-testid": CHECKBOX_INPUT
  }, topLabel && /*#__PURE__*/React.createElement(FieldContext, {
    "data-testid": CHECKBOX_TOP_LABEL
  }, topLabel), /*#__PURE__*/React.createElement("input", {
    disabled: disabled,
    type: "checkbox",
    id: id,
    name: name,
    checked: checked,
    onChange: onChange
  }), /*#__PURE__*/React.createElement("label", {
    "data-testid": CHECKBOX_LABEL,
    htmlFor: id
  }, /*#__PURE__*/React.createElement(LabelText, null, label)), error && errorText && /*#__PURE__*/React.createElement(FieldError, {
    errorText: errorText,
    fieldId: id
  }));
};

export { CheckboxInput };